import {View} from 'MWC';
import tpl from './templates/interactive.jsx';

export default class extends View {
    template = tpl;

    static displayName = 'SpecialOffers';
}
